import { formatBN } from "@gearbox-protocol/sdk/onchain";
import useAsyncRetry from "react-use/lib/useAsyncRetry";
import { erc20Abi, type PublicClient } from "viem";

import { useFaucet } from "./FaucetProvider";

export type Balance = [symbol: string, balance: string];

export function useTokenBalances(
  client?: PublicClient,
  address?: string | null,
) {
  const { assets } = useFaucet();

  return useAsyncRetry<Balance[]>(async () => {
    if (!client || !address) {
      return [];
    }

    const contracts = assets.map(t => ({
      address: t.address,
      abi: erc20Abi,
      functionName: "balanceOf",
      args: [address],
    }));

    const raw = await client.multicall({
      contracts,
      allowFailure: true,
    });
    const newBalances: Array<[string, string]> = [];
    for (let i = 0; i < raw.length; i++) {
      const v = BigInt(raw[i].result ?? 0);
      if (v && v > 10n) {
        newBalances.push([
          assets[i].symbol,
          formatBN(raw[i].result, assets[i].decimals),
        ]);
      }
    }
    return newBalances;
  }, [client, address]);
}

export type UseTokenBalances = ReturnType<typeof useTokenBalances>;
